
import { Record } from 'immutable'
const Search = Record({
  name:null,
  area:null,
  date:null,
  limit:null
});
export default Search;
